import * as C from '../constants';
import TwentyService from '../../../services/twenty-service';

export default {

  /**
   * Retrieve a list of countries.
   *
   * @param commit
   * @returns {Promise<any>}
   */
  countriesLoad({ commit }) {
    commit(C.TWENTY_COUNTRIES_LOAD_PENDING);
    return TwentyService.getCountries()
      .then((res) => {
        const countries = {};
        res.data.forEach((country) => {
          countries[country.id] = {
            id: country.id,
            name: country.name,
          };
        });
        commit(C.TWENTY_COUNTRIES_LOAD_SUCCESS, countries);
      })
      .catch((err) => {
        commit(C.TWENTY_COUNTRIES_LOAD_FAILURE, err.response.data);
      });
  },

  /**
   * Retrieve a list of areas for a country.
   *
   * @param commit
   * @param payload
   * @returns {Promise<any>}
   */
  areasLoad({ commit }, payload) {
    commit(C.TWENTY_AREAS_LOAD_PENDING);
    return TwentyService.getAreasForCountry(payload)
      .then((res) => {
        commit(C.TWENTY_AREAS_LOAD_SUCCESS, res.data);
      })
      .catch((err) => {
        commit(C.TWENTY_AREAS_LOAD_FAILURE, err.response.data);
      });
  },

  /**
   * Clear the current loaded areas.
   *
   * @param commit
   */
  areasClear({ commit }) {
    commit(C.TWENTY_AREAS_CLEAR);
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/twenty/actions.js